import React, {Component, Fragment} from 'react';
import '../../App.css';

import Modal from 'react-responsive-modal';
import request from 'request-promise-native';

import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Form from 'react-bootstrap/lib/Form';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Button from 'react-bootstrap/lib/Button';
import HelpBlock from "react-bootstrap/lib/HelpBlock";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Alert from "react-bootstrap/lib/Alert";
import ValidatedFormComponent from "../ValidatedFormComponent";
import AzureTable from "../AzureTable";
import "react-table/react-table.css";
import CardSub from "../subcomponents/CardSub";
import Row from "react-bootstrap/es/Row";
import LoadingModal from "../../utils/modals/LoadingModal";
import FailedDialog from "../../utils/modals/FailedDialog";

const ADD_DEVICE_ENDPOINT = "https://qibipay.azurewebsites.net/api/VMAdd";
const CONFIGURE_DEVICE_ENDPOINT = "https://qibipay.azurewebsites.net/api/VMConfig";

const GET_CARDS_URL = "https://qibipay.azurewebsites.net/api/GetRecipeList";

const mdbCurrencyCodes = {
    CHF: "0x1756",
    USD: "0x1840",
    EUR: "0x1978"
};

class DeviceConfig extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - open
             - tableRef
             - logout

             - onLoading
             - onHideBtn

             - device

             - ref
        */
        super(props);

        this.state = {
            errors: {

            },
            name: '',
            regId: '',
            updateInterval: 12,
            type: 'mdb',
            possibleOptions: [
                {
                    value: 'mdb',
                    name: 'MDB Cashless'
                },
                {
                    value: 'relay',
                    name: 'Relay'
                },
                {
                    value: 'vimasim',
                    name: 'Vimasim'
                },
                {
                    value: "tele",
                    name: "Telemetry"
                },
                {
                    value: "contact",
                    name: "Contact Closure"
                },
                {
                    value: "twint",
                    name: "Twint Beacon"
                },
                {
                    value: "twintqr",
                    name: "Twint QR"
                }
            ],
            description: '',
            activationPrice: 1,

            supportCash: "false",
            supportCashless: "true",
            alwaysIdle: "true",
            supportQibaccount: "true",
            supportDash: "false",


            //Contact closure
            coinAcceptorPin: 0,
            coinAcceptorReadyPin: 0,
            coinAcceptorPulseValue: 0.1,

            //Watch coin acceptor
            watchCoinAcceptorPin: 0,
            watchCoinAcceptorPulseValue: 0.1,
            watchCoinAcceptorTimeoutMillis: 1000,

            vendTimeout: 60,

            defaultPriceLevel: 0,
            useCloudPayments: "false",
            mailUser: "",
            useModem: false,

            endSessionWhenRemoved: "false",
            inLogic: "discrete",

            outputDefaultTime: 3,
            outDenyValue: 0,
            outSuccessValue: "static",
            outSuccessStaticOut: 1,
            outSuccessPriceDivider: 0.5,
            outType: "output",
            usePulses: "false",
            pulseFreq: 2,
            pulsePin: 2,

            readyPin: 0,
            endSessionValue: 0,

            mypos: "false",
            currency: "978",

            parallelVend: true,

            chooseRecipesOpen: false,

            loading: false,
            success: false
        };

        if(props.submitFunc!=null) {
            props.submitFunc(this.submit.bind(this));
        }

        if(props.device!=null) {
            const stateObj = this.getStateFromProps(props);

            console.log("State obj: ", stateObj);

            for(let key in stateObj) {
                this.state[key] = stateObj[key];
            }
        }

    }

    getStateFromProps(props) {
        const state = {};

        state.name = props.device.name;
        state.regId = props.device.regId;
        state.updateInterval = props.device.interval;
        state.mdbAddr = props.device.mdbAddr;
        state.overrideUrl = props.device.overrideUrl;
        if(props.device.regId.startsWith("$")) {
            state.possibleOptions = [
                {
                    value: 'mdb',
                    name: 'MDB Cashless'
                },
                {
                    value: 'vimasim',
                    name: 'Vimasim'
                },
                {
                    value: "tele",
                    name: "Telemetry"
                },
                {
                    value: "contact",
                    name: "Contact Closure"
                },
                {
                    value: "twint",
                    name: "Twint Beacon"
                },
                {
                    value: "twintqr",
                    name: "Twint QR"
                }
            ];
        } else if(props.device.regId.startsWith("&")) {
            state.possibleOptions = [
                {
                    value: 'mdb',
                    name: 'MDB Cashless'
                }
            ];
        }
        state.type = props.device.vimasim ? 'vimasim' : props.device.type!=null ? props.device.type : props.device.usemdb ? 'mdb' : 'relay';
        state.description = props.device.description;
        state.activationPrice = props.device.defaultPrice;
        state.inputType = props.device.inputType;
        state.inputBaud = props.device.baud;
        state.cloudPayVendTimeout = props.device.cloudTimeout;
        if(props.device.configuration!=null) {

            const conf = props.device.configuration;

            if(props.device.type==="contact") {
                for(let key in props.device.configuration) {
                    if(key==="mypos" || key==="useCloudPayments") {
                        state[key] = ""+props.device.configuration[key];
                    } else {
                        state[key] = props.device.configuration[key];
                    }
                }

                if(conf["sshTunnel"]!=null) {
                    const arr = conf["sshTunnel"].split(";");
                    if(arr.length>3) {
                        const forward = arr[3];
                        const arr2 = forward.split("-");
                        const from = arr2[0];
                        const to = arr2[1];
                        state.sshTunnel = to;
                        console.log("SSH Tunnel to: "+to);
                    }
                }

                return state;
            }

            state.beaconType = conf["useBeacon"] ? "beacon" : "qrcode";

            if(props.device.type==="twint") {
                for(let key in props.device.configuration) {
                    if(key==="alwaysIdle") {
                        state[key] = ""+props.device.configuration[key];
                    } else {
                        state[key] = props.device.configuration[key];
                    }
                }

                if(conf["sshTunnel"]!=null) {
                    const arr = conf["sshTunnel"].split(";");
                    if(arr.length>3) {
                        const forward = arr[3];
                        const arr2 = forward.split("-");
                        const from = arr2[0];
                        const to = arr2[1];
                        state.sshTunnel = to;
                        console.log("SSH Tunnel to: "+to);
                    }
                }

                return state;
            }

            if(props.device.type==="twintqr") {
                for(let key in props.device.configuration) {
                    if(key==="alwaysIdle") {
                        state[key] = ""+props.device.configuration[key];
                    } else {
                        state[key] = props.device.configuration[key];
                    }
                }

                if(conf["sshTunnel"]!=null) {
                    const arr = conf["sshTunnel"].split(";");
                    if(arr.length>3) {
                        const forward = arr[3];
                        const arr2 = forward.split("-");
                        const from = arr2[0];
                        const to = arr2[1];
                        state.sshTunnel = to;
                        console.log("SSH Tunnel to: "+to);
                    }
                }

                return state;
            }

            if(conf["sshTunnel"]!=null) {
                const arr = conf["sshTunnel"].split(";");
                if(arr.length>3) {
                    const forward = arr[3];
                    const arr2 = forward.split("-");
                    const from = arr2[0];
                    const to = arr2[1];
                    state.sshTunnel = to;
                    console.log("SSH Tunnel to: "+to);
                }
            }

            state.cashless_address = conf.cashless_address;
            state.be_cashless = conf.be_cashless;

            state.logLevel = conf.verbosity;
            state.logTarget = conf.logto;
            state.logUdpAddress = conf["log-udp-address"];
            state.logUdpPort = conf["log-udp-port"];
            state.currencySymbol = conf["currency-symbol"];
            state.ui = conf.ui;
            state.websocketPort = conf["websocket-port"];
            state.alwaysIdle = conf["cashless-always-idle"];
            state.supportCashless = conf["cashless-usecashless"];
            state.supportCash = conf["cashless-usecash"];
            state.supportQibaccount = conf["cashless-useqibaccount"];
            state.supportDash = conf["cashless-usedash"];
            state.dashAddress = conf["cashless-dashaddress"];

            state.dashTimeout = conf["cashless-dash-timeout"];
            state.qibaccountTimeout = conf["cashless-qibaccount-timeout"]
            state.useVemio = conf["vemio-usevemio"];

            state.recipeId = conf["recipeId"];
            state.recipeName = conf["recipeName"];

            state.cashregisterId = conf["cashregisterId"];
            state.merchantUuid = conf["merchantUuid"];
            state.supportTwint = conf["cashless-usetwint"];
            state.twintTimeout = conf["cashless-twint-timeout"];
            state.usePassthrough = conf.usePassthrough;

            state.logUdpAddr = conf["logUdpAddr"];
            state.logUdpPort = conf["logUdpPort"];

        }
        return state;
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.device!=null && (prevProps.device==null || prevProps.device.regId!==this.props.device.regId)) {
            this.setState(this.getStateFromProps(this.props));
        }
    }

    async submit() {

        let conf = {};

        if(this.nameRef.validated() && (this.props.device || this.regIdRef.validated()) && this.intervalRef.validated() && (this.state.type==="mdbForce" || this.typeRef.validated()) && (this.state.type=="vimasim" || this.state.type==="relay" || this.state.type==="contact" || this.state.type==="tele" || this.mdbAddrRef.validated())) {
            console.log("Verify 1");
            if(!this.sshTunnelRef.validated()) return;
            if(this.props.admin && !this.overrideUrlRef.validated()) return;
            if(this.state.type==="relay" || this.state.type==="mdb") {
                if(!this.inputTypeRef.validated()) {
                    return;
                }
                if(this.state.inputType==="serial") {
                    if(!this.inputBaudRef.validated()) {
                        return;
                    }
                }
                if(this.state.inputType==="cloud") {
                    if(!this.cloudPayVendTimeoutRef.validated()) {
                        return;
                    }
                }
            }
            if(this.state.type==='relay') {
                if(!this.activationPriceRef.validated()) {
                    return;
                }
            }

            let sshTunnel = "";
            const sshTunnelVal = parseInt(this.sshTunnelRef.value);
            if(!isNaN(sshTunnelVal)){
                sshTunnel = "worm.qibixx.com;22;external;22-"+sshTunnelVal;
            }

            if(this.state.type==='contact') {
                if(!this.inLogicRef.validated() ||
                    !this.endSessionWhenRemovedRef.validated() ||
                    !this.parallelVendRef.validated() ||
                    !this.outDenyValueRef.validated() ||
                    !this.outSuccessValueRef.validated() ||
                    !this.outTypeRef.validated() ||
                    !this.usePulsesRef.validated() ||
                    !this.useCloudPaymentsRef.validated()) {
                    return;
                }

                conf.inLogic = this.inLogicRef.value;
                conf.endSessionWhenRemoved = this.endSessionWhenRemovedRef.value;
                conf.outDenyValue = parseInt(this.outDenyValueRef.value);
                conf.outSuccessValue = this.outSuccessValueRef.value;
                conf.outType = this.outTypeRef.value;
                conf.usePulses = this.usePulsesRef.value;
                conf.parallelVend = this.parallelVendRef.value;
                conf.useCloudPayments = this.useCloudPaymentsRef.value;
                conf.sshTunnel = sshTunnel;

                if(this.readyPinEnableRef.value==="true") {
                    if(!this.readyPinRef.validated()) {
                        return;
                    }
                    conf.readyPin = parseInt(this.readyPinRef.value);
                } else {
                    conf.readyPin = 0;
                }

                if(this.busyPinEnableRef.value==="true") {
                    if(!this.busyPinRef.validated()) {
                        return;
                    }
                    conf.busyPin = parseInt(this.busyPinRef.value);
                } else {
                    conf.busyPin = 0;
                }

                if(this.endSessionWhenRemovedRef.value==="false") {
                    if(!this.outputDefaultTimeRef.validated()) {
                        return;
                    }
                    if(this.endSessionEnableRef.value==="true") {
                        if(!this.endSessionValueRef.validated()) {
                            return;
                        }
                        conf.endSessionValue = parseInt(this.endSessionValueRef.value);
                    } else {
                        conf.endSessionValue = 0;
                    }
                    conf.outputDefaultTime = parseInt(this.outputDefaultTimeRef.value);
                }

                if(this.outSuccessValueRef.value==="static") {
                    if(!this.outSuccessStaticOutRef.validated()) {
                        return;
                    }
                    conf.outSuccessStaticOut = parseInt(this.outSuccessStaticOutRef.value);
                }

                if(this.outSuccessValueRef.value==="price") {
                    if(!this.outSuccessPriceDividerRef.validated()) {
                        return;
                    }
                    conf.outSuccessPriceDivider = parseFloat(this.outSuccessPriceDividerRef.value);
                }

                if(this.state.usePulses==="true") {
                    if(!this.pulsePinRef.validated() ||
                        !this.pulseFreqRef.validated()) {
                        return;
                    }
                    conf.pulsePin = parseInt(this.pulsePinRef.value);
                    conf.pulseFreq = parseFloat(this.pulseFreqRef.value);
                }

                if(this.cashlessEnableRef.value==="true") {
                    if(!this.vendTimeoutRef.validated()) {
                        return;
                    }

                    conf.vendTimeout = parseInt(this.vendTimeoutRef.value);
                    conf.mypos = this.state.mypos;

                    if(conf.mypos==="true") {
                        if(!this.currencyRef.validated()) {
                            return;
                        }
                        conf.currency = this.currencyRef.value;
                    } else if(conf.mypos==="false") {
                        if(!this.defaultPriceLevelRef.validated()) {
                            return;
                        }
                        conf.defaultPriceLevel = parseInt(this.defaultPriceLevelRef.value);
                    }
                } else {
                    conf.mypos = "nil";
                }

                if(this.coinAcceptorEnableRef.value==="true") {
                    if(this.coinAcceptorTypeRef.value==="gpio") {
                        if(!this.coinAcceptorPinRef.validated()) {
                            return;
                        }
                        if(!this.coinAcceptorEnablePinRef.validated() ||
                            !this.coinAcceptorPulseValueRef.validated()) {
                            return;
                        }
                        conf.coinAcceptorEnablePin = parseInt(this.coinAcceptorEnablePinRef.value);
                        conf.coinAcceptorPulseValue = parseFloat(this.coinAcceptorPulseValueRef.value);
                        conf.coinAcceptorPin = parseInt(this.coinAcceptorPinRef.value);
                    } else {
                        conf.coinAcceptorPin = -1;
                    }
                } else {
                    conf.coinAcceptorPin = 0;
                }

                if(this.useCloudPaymentsRef.value==="true") {
                    if(!this.useModemRef.validated() ||
                        !this.mailUserRef.validated() ||
                        !this.cloudKeepaliveRef.validated() ||
                        !this.cashregisterIdRef.validated() ||
                        !this.merchantUuidRef.validated()) {
                        return;
                    }
                    conf.cashregisterId = this.cashregisterIdRef.value;
                    conf.merchantUuid = this.merchantUuidRef.value;
                    conf.cloudKeepalive = parseInt(this.cloudKeepaliveRef.value);
                    conf.useModem = this.useModemRef.value==="true";
                    /*if(conf.useModem) {
                        conf.cloudIp = "10.64.79.125";
                        conf.cloudPort = 52131;
                    } else {
                        conf.cloudIp = "116.203.249.28";
                        conf.cloudPort = 52131;
                    }*/
                    conf.mailUser = this.mailUserRef.value;
                }

                if(this.watchCoinAcceptorPinEnableRef.value==="true") {
                    if(
                        !this.watchCoinAcceptorPinRef.validated() ||
                        !this.watchCoinAcceptorPulseValueRef.validated() ||
                        !this.watchCoinAcceptorTimeoutMillisRef.validated()
                    ) {
                        return;
                    }
                    conf.watchCoinAcceptorPin = parseInt(this.watchCoinAcceptorPinRef.value);
                    conf.watchCoinAcceptorPulseValue = parseFloat(this.watchCoinAcceptorPulseValueRef.value);
                    conf.watchCoinAcceptorTimeoutMillis = parseInt(this.watchCoinAcceptorTimeoutMillisRef.value);
                } else {
                    conf.watchCoinAcceptorPin = 0;
                }

                for(let i = 1;i<16;i++) {
                    if(i<10) {
                        i = "0"+i;
                    }
                    if(!this["price"+i+"Ref"].validated() ||
                        !this["price"+i+"typeRef"].validated()) {
                        return;
                    }
                    conf["price"+i] = parseFloat(this["price"+i+"Ref"].value);
                    conf["price"+i+"type"] = this["price"+i+"typeRef"].value;
                    if(conf["price"+i+"type"]==="timed") {
                        if(!this["price"+i+"pinRef"].validated() ||
                            !this["price"+i+"timeRef"].validated()) {
                            return;
                        }
                        conf["price"+i+"pin"] = parseInt(this["price"+i+"pinRef"].value);
                        conf["price"+i+"time"] = parseInt(this["price"+i+"timeRef"].value);
                    }
                    if(conf["price"+i+"type"]==="pulsed") {
                        if(!this["price"+i+"pinRef"].validated() ||
                            !this["price"+i+"pulsesRef"].validated()) {
                            return;
                        }
                        conf["price"+i+"pin"] = parseInt(this["price"+i+"pinRef"].value);
                        conf["price"+i+"pulses"] = parseInt(this["price"+i+"pulsesRef"].value);
                    }
                    if(conf["price"+i+"type"]==="fixed") {
                        if(!this["price"+i+"valueRef"].validated()) {
                            return;
                        }
                        conf["price"+i+"value"] = parseInt(this["price"+i+"valueRef"].value);
                    }
                    if(!this["price"+i+"twintqrRef"].validated()) {
                        return;
                    }
                    conf["price"+i+"twintqr"] = this["price"+i+"twintqrRef"].value;
                }

            }
            if(this.state.type==='tele') {
                if(!this.cashless_addressRef.validated() ||
                    !this.be_cashlessRef.validated()) {
                    return;
                }
            }

            if(this.state.type==='twint') {
                if(!this.mdbAddrRef.validated() ||
                    !this.alwaysIdleRef.validated() ||
                    !this.vendTimeoutRef.validated() ||
                    !this.currencyCodeRef.validated() ||
                    !this.cashregisterIdRef.validated() ||
                    !this.beaconTypeRef.validated() ||
                    !this.merchantUuidRef.validated() ||
                    !this.logUdpAddrRef.validated() ||
                    !this.logUdpPortRef.validated()) {
                    return;
                }
                if(this.alwaysIdleRef.value==="false") {
                    if(!this.authAmountRef.validated()) {
                        return;
                    }
                }
            }

            if(this.state.type==='twintqr') {
                if(!this.mdbAddrRef.validated() ||
                    !this.vendTimeoutRef.validated() ||
                    !this.currencyCodeRef.validated() ||
                    !this.cashregisterIdRef.validated() ||
                    !this.authAmountRef.validated() ||
                    !this.merchantUuidRef.validated() ||
                    !this.logUdpAddrRef.validated() ||
                    !this.logUdpPortRef.validated() ||
                    !this.passthroughRef.validated() ||
                    !this.autocreditRef.validated()) {
                    return;
                }
            }

            if(this.state.type==="vimasim") {
                if(!this.logLevelRef.validated() ||
                    !this.logTargetRef.validated() ||
                    !this.currencySymbolRef.validated() ||
                    !this.uiRef.validated() ||
                    !this.alwaysIdleRef.validated() ||
                    !this.supportCashRef.validated() ||
                    !this.supportQibaccountRef.validated() ||
                    !this.supportDashRef.validated() ||
                    !this.supportCashlessRef.validated() ||
                    !this.useVemioRef.validated() ||
                    !this.supportTwintRef.validated()) {
                    return;
                }
                if(this.state.logTarget==="udp") {
                    if(!this.logUdpAddressRef.validated() || !this.logUdpPortRef.validated()) {
                        return;
                    }
                }
                if(this.state.ui==="web") {
                    if(!this.websocketPortRef.validated()) {
                        return;
                    }
                }
                if(this.state.supportDash==="true") {
                    if(!this.dashAddressRef.validated() || !this.dashTimeoutRef.validated()) {
                        return;
                    }
                }
                if(this.state.supportQibaccount==="true") {
                    if(!this.qibaccountTimeoutRef.validated()) {
                        return;
                    }
                }
                if(this.state.supportTwint==="true") {
                    if(!this.twintTimeoutRef.validated() ||
                        !this.cashregisterIdRef.validated() ||
                        !this.merchantUuidRef.validated()) {
                        return;
                    }
                }
            }

            let overrideUrl = null;
            if(this.props.admin) {
                overrideUrl = this.overrideUrlRef.value;
            }

            const options = {
                method: 'POST',
                uri: this.props.device ? CONFIGURE_DEVICE_ENDPOINT : ADD_DEVICE_ENDPOINT,
                body: this.state.type!=="vimasim" ? (this.state.type==="twint" ? {
                    access_code: this.props.access_code,
                    name: this.nameRef.value,
                    regId: this.props.device ? this.props.device.regId : this.regIdRef.value,
                    interval: this.intervalRef.value,
                    vimasim: false,
                    description: this.descriptionRef.value,
                    type: "twint",
                    overrideUrl,
                    config: {
                        mdbAddr: this.mdbAddrRef.value,
                        alwaysIdle: this.alwaysIdleRef.value==="true",
                        vendTimeout: parseInt(this.vendTimeoutRef.value),
                        currencyCode: this.currencyCodeRef.value,
                        mdbCurrencyCode: mdbCurrencyCodes[this.currencyCodeRef.value],
                        cashregisterId: this.cashregisterIdRef.value,
                        merchantUuid: this.merchantUuidRef.value,
                        authAmount: this.alwaysIdleRef.value==="false" ? parseFloat(this.authAmountRef.value) : 5,
                        useBeacon: this.alwaysIdleRef.value==="false" ? true : this.beaconTypeRef.value==="beacon",
                        logUdpAddr: this.logUdpAddrRef.value,
                        logUdpPort: this.logUdpPortRef.value,
                        sshTunnel
                    }
                } : this.state.type==="twintqr" ? {
                    access_code: this.props.access_code,
                    name: this.nameRef.value,
                    regId: this.props.device ? this.props.device.regId : this.regIdRef.value,
                    interval: this.intervalRef.value,
                    vimasim: false,
                    description: this.descriptionRef.value,
                    type: "twintqr",
                    overrideUrl,
                    config: {
                        mdbAddr: this.mdbAddrRef.value,
                        vendTimeout: parseInt(this.vendTimeoutRef.value),
                        currencyCode: this.currencyCodeRef.value,
                        mdbCurrencyCode: mdbCurrencyCodes[this.currencyCodeRef.value],
                        cashregisterId: this.cashregisterIdRef.value,
                        merchantUuid: this.merchantUuidRef.value,
                        authAmount: parseFloat(this.authAmountRef.value) || 5,
                        //cloudIp: "116.203.249.28",
                        //cloudPort: 52131,
                        logUdpAddr: this.logUdpAddrRef.value,
                        logUdpPort: this.logUdpPortRef.value,
                        usePassthrough: this.passthroughRef.value=="true",
                        autoCredit: this.autocreditRef.value=="true",
                        sshTunnel
                    }
                } : this.state.type==="tele" ? {
                    access_code: this.props.access_code,
                    name: this.nameRef.value,
                    regId: this.props.device ? this.props.device.regId : this.regIdRef.value,
                    interval: this.intervalRef.value,
                    description: this.descriptionRef.value,
                    vimasim: false,
                    type: "tele",
                    overrideUrl,
                    config: {
                        cashless_address: this.cashless_addressRef.value,
                        be_cashless: this.be_cashlessRef.value==="true" || this.be_cashlessRef.value===true,
                        sshTunnel
                    }
                } : this.state.type==="contact" ? {
                    access_code: this.props.access_code,
                    name: this.nameRef.value,
                    regId: this.props.device ? this.props.device.regId : this.regIdRef.value,
                    interval: this.intervalRef.value,
                    description: this.descriptionRef.value,
                    vimasim: false,
                    type: "contact",
                    overrideUrl,
                    config: conf
                } : {
                    access_code: this.props.access_code,
                    name: this.nameRef.value,
                    regId: this.props.device ? this.props.device.regId : this.regIdRef.value,
                    interval: this.intervalRef.value,
                    usemdb: this.state.type!=='relay',
                    mdbAddr: this.state.type==='relay' ? "0x10" : this.mdbAddrRef.value,
                    description: this.descriptionRef.value,
                    defaultPrice: this.activationPriceRef==null || this.activationPriceRef.value==null ? 1 : this.activationPriceRef.value,
                    inputType: this.state.inputType,
                    //cloudTimeout: parseInt(this.cloudPayVendTimeoutRef.value),
                    baud: this.state.inputBaud,
                    vimasim: false,
                    overrideUrl,
                    sshTunnel
                }) : {
                    access_code: this.props.access_code,
                    name: this.nameRef.value,
                    regId: this.props.device ? this.props.device.regId : this.regIdRef.value,
                    interval: this.intervalRef.value,
                    usemdb: true,
                    description: this.descriptionRef.value,
                    vimasim: true,
                    overrideUrl,
                    config: {
                        verbosity: this.state.logLevel,
                        logto: this.state.logTarget,
                        "log-udp-address": this.state.logUdpAddress,
                        "log-udp-port": this.state.logUdpPort,
                        "currency-symbol": this.state.currencySymbol,
                        ui: this.state.ui,
                        "websocket-port": this.state.websocketPort,
                        "cashless-always-idle": this.state.alwaysIdle,
                        "cashless-usecashless": this.state.supportCashless,
                        "cashless-usecash": this.state.supportCash,
                        "cashless-useqibaccount": this.state.supportQibaccount,
                        "cashless-usedash": this.state.supportDash,
                        "cashless-dashaddress": this.state.dashAddress,
                        "vemio-usevemio": this.state.useVemio,
                        "cashless-dash-timeout": this.state.dashTimeout,
                        "cashless-qibaccount-timeout": this.state.qibaccountTimeout,
                        recipeId: this.state.recipeId,
                        recipeName: this.state.recipeName,
                        "cashless-usetwint": this.state.supportTwint,
                        cashregisterId: this.state.cashregisterId,
                        merchantUuid: this.merchantUuidRef.value,
                        "cashless-twint-timeout": this.state.twintTimeout,
                        sshTunnel
                    }
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const cpy = {...this.props.device};
            for(let key in options.body) {
                if(key!="access_code") {
                    if(key=="config") {
                        cpy["configuration"] = options.body[key];
                    } else {
                        cpy[key] = options.body[key];
                    }
                }
            }

            if(this.props.device!=null) {
                this.setState({configuring: true, errors:{}, errorMessage:null});
            } else {
                this.setState({loading: true, errors:{}, errorMessage:null});
            }

            if(this.props.onLoading!=null) {
                this.props.onLoading(true);
            }

            const response = await request(options);

            console.log("Response",response);

            if(this.props.onLoading!=null) {
                this.props.onLoading(false);
            }

            if(this.props.device!=null) {
                this.setState({configuring: false});
            } else {
                this.setState({loading: false});
            }

            if(response.statusCode===404) {
                this.props.logout();
                return;
            }

            if(response.statusCode===400) {
                if(response.body.field!=null) {
                    const errors = {};
                    errors[response.body.field] = response.body.msg;
                    this.setState({errors: errors});
                } else {
                    this.setState({errorMessage: response.body.msg!=null ? response.body.msg : response.body});
                }
                return;
            }

            if(response.statusCode!==200) {
                this.setState({errorMessage: 'Server error occured, please retry.'});
                return;
            }

            if(this.props.device==null) {
                this.setState({
                    success: true
                });

                if(this.props.onHideBtn!=null) {
                    this.props.onHideBtn(true);
                }
            }

            //Success
            if(this.props.tableRef!=null) {
                this.props.tableRef.resetTable();
            }
            if(this.props.onSave!=null) this.props.onSave(cpy);
        }
    }

    _reset() {
        this.setState({
            errors: {

            },
            name: '',
            regId: '',
            updateInterval: 12,
            type: 'mdb',
            overrideUrl: "",
            possibleOptions: [
                {
                    value: 'mdb',
                    name: 'MDB Cashless'
                },
                {
                    value: 'relay',
                    name: 'Relay'
                },
                {
                    value: 'vimasim',
                    name: 'Vimasim'
                },
                {
                    value: "tele",
                    name: "Telemetry"
                },
                {
                    value: "contact",
                    name: "Contact Closure"
                },
                {
                    value: "twint",
                    name: "Twint Beacon"
                },
                {
                    value: "twintqr",
                    name: "Twint QR"
                }
            ],
            description: '',
            activationPrice: 1,
            inputType: "hid",
            inputBaud: "115200",

            cashless_address: "0x60",

            supportCash: "false",
            supportCashless: "true",
            alwaysIdle: "true",
            supportQibaccount: "true",
            supportDash: "false",

            //Contact closure
            coinAcceptorPin: 0,
            coinAcceptorReadyPin: 0,
            coinAcceptorPulseValue: 0.1,

            //Watch coin acceptor
            watchCoinAcceptorPin: 0,
            watchCoinAcceptorPulseValue: 0.1,
            watchCoinAcceptorTimeoutMillis: 1000,

            vendTimeout: 60,

            defaultPriceLevel: 0,
            useCloudPayments: "false",
            mailUser: "",
            useModem: false,

            endSessionWhenRemoved: "false",
            inLogic: "discrete",

            outputDefaultTime: 3,
            outDenyValue: 0,
            outSuccessValue: "static",
            outSuccessStaticOut: 1,
            outSuccessPriceDivider: 0.5,
            outType: "output",
            usePulses: "false",
            pulseFreq: 2,
            pulsePin: 2,

            readyPin: 0,
            endSessionValue: 0,

            mypos: "false",
            currency: "978",

            multivend: true,

            chooseRecipesOpen: false,

            loading: false,
            success: false
        });
        this.props.onClose();
    }


    render() {
        if(!this.props.open) {
            return "";
        }

        return (
            <Fragment>

                <LoadingModal open={this.state.configuring}
                                title={"Configuring..."}
                                text={"Saving configuration"}/>

                <Modal open={this.state.chooseRecipesOpen} onClose={() => {
                    this.setState({
                        chooseRecipesOpen: false
                    })
                }} styles={{
                    modal: {
                        minWidth: '800px'
                    }
                }} >
                    <h2>Set the recipe</h2>
                    <AzureTable
                        logout={this.props.logout}
                        access_code={this.props.access_code}
                        onLoad={() => {
                            this.setState({
                                loading: false
                            });
                        }}
                        tableRef={(ref) => {
                            this.tableRef = ref;
                        }}
                        functionUrl={GET_CARDS_URL}
                        defaultSorted={[
                            {
                                id: "name",
                                desc: false
                            }
                        ]}
                        getTdProps={(state, rowInfo, column, instance) => {
                            if(rowInfo!=null && column.Header!=='Delete') return {
                                style: {
                                    cursor: 'pointer'
                                },
                                onClick: e => {
                                    console.log("Cell - onClick", rowInfo.original);
                                    this.setState({
                                        chooseRecipesOpen: false,
                                        recipeId: rowInfo.original.id,
                                        recipeName: rowInfo.original.name
                                    });
                                }
                            };
                            return {};
                        }}
                        columns={[
                            {
                                Header: "ID",
                                accessor: "id",
                                filterable: true,
                                sortable: true,
                            },
                            {
                                Header: "Name",
                                accessor: "name",
                                sortable: true,
                                filterable: true
                            },
                            {
                                Header: "Description",
                                accessor: "description",
                                sortable: false,
                                filterable: false
                            }
                        ]}
                        filterable
                        defaultPageSize={10}
                        className="-striped -highlight"
                        pageSize={10}
                    />
                </Modal>

                    {this.state.errorMessage!=null ? (<Alert bsStyle="danger">
                        <strong>{this.state.errorMessage}</strong>
                    </Alert>) : ''}

                    {this.state.loading ? (
                        <div>
                            <p>{this.props.device===null ? 'Adding' : 'Configuring'} device...</p>
                            <ProgressBar  active now={100}/>
                        </div>
                    ) : this.state.success ? (
                        <div>
                            <p>Device {this.props.device===null ? 'added' : 'configured'}  successfully!</p>
                        </div>
                    ) : (
                        <Form horizontal style={{
                            marginLeft: "32px",
                            marginRight: "32px"
                        }}>

                            <Col className={this.props.device==null ? "" : "pr-5"} xs={12} sm={12} md={12} lg={this.props.device==null ? 12 : 6}>
                                <div class="m-2">

                                <Row>
                                    <h3><i className="fa fa-cogs"></i> General</h3>
                                </Row>

                                <ValidatedFormComponent name="Name"
                                                        type="text"
                                                        placeholder="Enter device name"
                                                        value={this.state.name}
                                                        onChange={(value) => {
                                                            this.setState({name: value});
                                                        }}
                                                        onValidate={input => {
                                                            return input==='' ? "Device name cannot be empty!" : null;
                                                        }}
                                                        inputRef={ref => this.nameRef=ref}
                                />
                                {this.props.device ? '' : (<ValidatedFormComponent name="Registration ID"
                                                                                   type="text"
                                                                                   value={this.state.regId}
                                                                                   onChange={(value) => {
                                                                                       if(value.startsWith("$")) {
                                                                                           this.setState({
                                                                                               regId: value,
                                                                                               possibleOptions: [
                                                                                                   {
                                                                                                       value: 'mdb',
                                                                                                       name: 'MDB Cashless'
                                                                                                   },
                                                                                                   {
                                                                                                       value: 'vimasim',
                                                                                                       name: 'Vimasim'
                                                                                                   },
                                                                                                   {
                                                                                                       value: "tele",
                                                                                                       name: "Telemetry"
                                                                                                   },
                                                                                                   {
                                                                                                       value: "contact",
                                                                                                       name: "Contact Closure"
                                                                                                   },
                                                                                                   {
                                                                                                       value: "twint",
                                                                                                       name: "Twint Beacon"
                                                                                                   },
                                                                                                   {
                                                                                                       value: "twintqr",
                                                                                                       name: "Twint QR"
                                                                                                   }
                                                                                               ]
                                                                                           });
                                                                                       } else if(value.startsWith("&")) {
                                                                                           this.setState({
                                                                                               regId: value,
                                                                                               possibleOptions: [
                                                                                                   {
                                                                                                       value: 'mdb',
                                                                                                       name: 'MDB Cashless'
                                                                                                   }
                                                                                               ]
                                                                                           });
                                                                                       } else {
                                                                                           if(this.state.type==="mdbForce") {
                                                                                               this.setState({
                                                                                                   regId: value,
                                                                                                   possibleOptions: [
                                                                                                       {
                                                                                                           value: 'mdb',
                                                                                                           name: 'MDB Cashless'
                                                                                                       },
                                                                                                       {
                                                                                                           value: 'relay',
                                                                                                           name: 'Relay'
                                                                                                       },
                                                                                                       {
                                                                                                           value: 'vimasim',
                                                                                                           name: 'Vimasim'
                                                                                                       },
                                                                                                       {
                                                                                                           value: "tele",
                                                                                                           name: "Telemetry"
                                                                                                       },
                                                                                                       {
                                                                                                           value: "contact",
                                                                                                           name: "Contact Closure"
                                                                                                       },
                                                                                                       {
                                                                                                           value: "twint",
                                                                                                           name: "Twint Beacon"
                                                                                                       },
                                                                                                       {
                                                                                                           value: "twintqr",
                                                                                                           name: "Twint QR"
                                                                                                       }
                                                                                                   ]
                                                                                               });
                                                                                           } else {
                                                                                               this.setState({regId: value});
                                                                                           }
                                                                                       }
                                                                                   }}
                                                                                   placeholder="Enter device's registration ID"
                                                                                   onValidate={input => {
                                                                                       return input.length!==12 ? "Device's registration ID must be 12 characters long!" : null;
                                                                                   }}
                                                                                   inputRef={ref => this.regIdRef=ref}
                                />)}
                                <ValidatedFormComponent name="Update interval (hours)"
                                                        type="number"
                                                        value={this.state.updateInterval}
                                                        onChange={(value) => this.setState({updateInterval: value})}
                                                        min={1}
                                                        max={72}
                                                        placeholder="Enter device's connection interval"
                                                        onValidate={input => {
                                                            return null;
                                                        }}
                                                        inputRef={ref => this.intervalRef=ref}
                                />
                                {this.props.admin ? (
                                    <ValidatedFormComponent name="Override package URL"
                                                            type="text"
                                                            placeholder=""
                                                            value={this.state.overrideUrl}
                                                            onChange={(value) => {
                                                                this.setState({overrideUrl: value});
                                                            }}
                                                            onValidate={input => {
                                                                return null;
                                                            }}
                                                            inputRef={ref => this.overrideUrlRef=ref}
                                    />
                                ) : ""}
                                {this.state.type==="mdbForce" ? "" : (
                                    <ValidatedFormComponent name="Type"
                                                            type="select"
                                                            placeholder=""
                                                            onValidate={input => {
                                                                return null;
                                                            }}
                                                            value_key='value'
                                                            display_name_key='name'
                                                            options={this.state.possibleOptions}
                                                            value={this.state.type}
                                                            onChange={value => {
                                                                this.setState(
                                                                    {
                                                                        type: value
                                                                    }
                                                                )
                                                            }}
                                                            inputRef={ref => this.typeRef=ref}
                                    />
                                )}
                                    <FormGroup controlId="formControlsTextarea">
                                        <Col componentClass={ControlLabel} sm={4}>
                                            Description
                                        </Col>
                                        <Col sm={8}>
                                            <FormControl onChange={(evnt) => {
                                                this.setState({
                                                    description: evnt.target.value
                                                })
                                            }} value={this.state.description} componentClass="textarea" placeholder="Enter device description (not required)" inputRef={(ref) => this.descriptionRef = ref}/>
                                        </Col>
                                    </FormGroup>
                                    <Row>
                                        <h3>Advanced</h3>
                                    </Row>

                                    <ValidatedFormComponent name="Port forward port"
                                                            type="number"
                                                            placeholder=""
                                                            emptyAllowed={true}
                                                            min={50000}
                                                            max={65535}
                                                            step={1}
                                                            onValidate={input => {
                                                                return input.length>0 && isNaN(parseInt(input)) ? "Not a number" : null;
                                                            }}
                                                            value={this.state.sshTunnel == null ? "" : this.state.sshTunnel}
                                                            onChange={(value) => this.setState({sshTunnel: value})}
                                                            inputRef={ref => this.sshTunnelRef=ref}
                                    />

                                    <Row>
                                        <Col sm={4}>

                                        </Col>
                                        <Col onClick={() => {
                                            this.setState({
                                                sshTunnel: (50000+Math.floor(Math.random()*(65535-50000))).toString()
                                            });
                                        }} componentClass={Button} sm={8}>
                                            Random port
                                        </Col>
                                    </Row>

                                </div>

                                {this.state.type==='contact' ? (
                                    <>

                                        <Row>
                                            <h3><i className="fa fa-exchange-alt"></i> Input/Output</h3>
                                        </Row>

                                        <Row>
                                            <h4 className={"ml-3"}><i className="fa fa-sign-in-alt"></i> Input</h4>
                                        </Row>

                                        <ValidatedFormComponent name="Parallel vends"
                                                                type="boolean"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.parallelVend == null ? "true" : ""+this.state.parallelVend}
                                                                onChange={(value) => {
                                                                    const obj = {
                                                                        parallelVend: value==="true"
                                                                    };
                                                                    this.setState(obj)
                                                                }}
                                                                inputRef={ref => this.parallelVendRef=ref}
                                        />

                                        <ValidatedFormComponent name="Session Logic"
                                                                type="select"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value_key='value'
                                                                display_name_key='name'
                                                                options={[
                                                                    {
                                                                        value: 'true',
                                                                        name: 'Level activated/Release cancelled'
                                                                    },
                                                                    {
                                                                        value: 'false',
                                                                        name: 'Pulse activated'
                                                                    }
                                                                ]}
                                                                value={this.state.endSessionWhenRemoved == null ? "false" : this.state.endSessionWhenRemoved}
                                                                onChange={(value) => this.setState({endSessionWhenRemoved: value})}
                                                                inputRef={ref => this.endSessionWhenRemovedRef=ref}
                                        />

                                        <ValidatedFormComponent name="Input Format"
                                                                type="select"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value_key='value'
                                                                display_name_key='name'
                                                                options={[
                                                                    {
                                                                        value: 'discrete',
                                                                        name: 'Discrete'
                                                                    },
                                                                    {
                                                                        value: 'bcd',
                                                                        name: 'Binary (4-bit)'
                                                                    }
                                                                ]}
                                                                value={this.state.inLogic == null ? "discrete" : this.state.inLogic}
                                                                onChange={(value) => this.setState({inLogic: value})}
                                                                inputRef={ref => this.inLogicRef=ref}
                                        />


                                        <ValidatedFormComponent name="Ready pin"
                                                                type="boolean"
                                                                defaultValue={false}
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={""+(this.state.readyPin!==0 || this.state.readyPin==null)}
                                                                onChange={(value) => this.setState({readyPin: value=="true" ? 1 : 0})}
                                                                inputRef={ref => this.readyPinEnableRef=ref}
                                        />

                                        {this.state.readyPin>0 ? (
                                            <ValidatedFormComponent name=""
                                                                    type="number"
                                                                    placeholder=""
                                                                    min={1}
                                                                    max={8}
                                                                    step={1}
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.readyPin == null ? 1 : this.state.readyPin}
                                                                    onChange={(value) => this.setState({readyPin: parseInt(value)})}
                                                                    inputRef={ref => this.readyPinRef=ref}
                                            />
                                        ) : ""}

                                        {this.state.endSessionWhenRemoved==="false" ? (

                                            <>

                                                <ValidatedFormComponent name="Cancel pin"
                                                                        type="boolean"
                                                                        defaultValue={false}
                                                                        placeholder=""
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={""+(this.state.endSessionValue!==0 || this.state.endSessionValue==null)}
                                                                        onChange={(value) => this.setState({endSessionValue: value=="true" ? 1 : 0})}
                                                                        inputRef={ref => this.endSessionEnableRef=ref}
                                                />

                                                {this.state.endSessionValue>0 ? (
                                                    <ValidatedFormComponent name=""
                                                                            type="number"
                                                                            placeholder=""
                                                                            min={1}
                                                                            max={8}
                                                                            step={1}
                                                                            onValidate={input => {
                                                                                return null;
                                                                            }}
                                                                            value={this.state.endSessionValue == null ? 1 : this.state.endSessionValue}
                                                                            onChange={(value) => this.setState({endSessionValue: parseInt(value)})}
                                                                            inputRef={ref => this.endSessionValueRef=ref}
                                                    />
                                                ) : ""}

                                            </>

                                        ) : ""}

                                        <Row>
                                            <h4 className={"ml-3"}><i className="fa fa-sign-out-alt"></i> Output</h4>
                                        </Row>

                                        {this.state.endSessionWhenRemoved==="false" ? (
                                            <ValidatedFormComponent name="Default output duration"
                                                                    append="s"
                                                                    type="number"
                                                                    placeholder=""
                                                                    min={1}
                                                                    max={60000}
                                                                    step={1}
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.outputDefaultTime == null ? 3 : this.state.outputDefaultTime}
                                                                    onChange={(value) => this.setState({outputDefaultTime: parseInt(value)})}
                                                                    inputRef={ref => this.outputDefaultTimeRef=ref}
                                            />
                                        ) : ""}


                                        <ValidatedFormComponent name="Vend deny signal"
                                                                type="number"
                                                                placeholder=""
                                                                min={0}
                                                                max={15}
                                                                step={1}
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.outDenyValue == null ? 15 : this.state.outDenyValue}
                                                                onChange={(value) => this.setState({outDenyValue: parseInt(value)})}
                                                                inputRef={ref => this.outDenyValueRef=ref}
                                        />

                                        <ValidatedFormComponent name="Vend approve handling"
                                                                type="select"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value_key='value'
                                                                display_name_key='name'
                                                                options={[
                                                                    {
                                                                        value: 'inputNum',
                                                                        name: 'Product ID'
                                                                    },
                                                                    {
                                                                        value: 'price',
                                                                        name: 'Price'
                                                                    },
                                                                    {
                                                                        value: 'static',
                                                                        name: 'Static'
                                                                    }
                                                                ]}
                                                                value={this.state.outSuccessValue == null ? "static" : this.state.outSuccessValue}
                                                                onChange={(value) => this.setState({outSuccessValue: value})}
                                                                inputRef={ref => this.outSuccessValueRef=ref}
                                        />

                                        {this.state.outSuccessValue==="static" ? (
                                            <ValidatedFormComponent name="Output value"
                                                                    type="number"
                                                                    placeholder=""
                                                                    min={0}
                                                                    max={15}
                                                                    step={1}
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.outSuccessStaticOut == null ? 1 : this.state.outSuccessStaticOut}
                                                                    onChange={(value) => this.setState({outSuccessStaticOut: parseInt(value)})}
                                                                    inputRef={ref => this.outSuccessStaticOutRef=ref}
                                            />
                                        ) : ""}

                                        {this.state.outSuccessValue==="price" ? (
                                            <ValidatedFormComponent name="Price divider"
                                                                    type="number"
                                                                    defaultValue={0.5}
                                                                    placeholder=""
                                                                    min={0.01}
                                                                    max={100}
                                                                    step={0.01}
                                                                    decimal={true}
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.outSuccessPriceDivider == null ? 0.5 : this.state.outSuccessPriceDivider}
                                                                    onChange={(value) => this.setState({outSuccessPriceDivider: parseFloat(value)})}
                                                                    inputRef={ref => this.outSuccessPriceDividerRef=ref}
                                            />
                                        ) : ""}


                                        <ValidatedFormComponent name="Default Output Format"
                                                                type="select"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value_key='value'
                                                                display_name_key='name'
                                                                options={[
                                                                    {
                                                                        value: 'output',
                                                                        name: 'Discrete'
                                                                    },
                                                                    {
                                                                        value: 'binary',
                                                                        name: 'Binary (4-bit)'
                                                                    },
                                                                    {
                                                                        value: 'disable',
                                                                        name: 'Disable'
                                                                    }
                                                                ]}
                                                                value={this.state.outType == null ? "output" : this.state.outType}
                                                                onChange={(value) => this.setState({outType: value})}
                                                                inputRef={ref => this.outTypeRef=ref}
                                        />

                                        <ValidatedFormComponent name="Pulses"
                                                                type="boolean"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.usePulses == null ? "false" : this.state.usePulses}
                                                                onChange={(value) => {
                                                                    const obj = {
                                                                        usePulses: value
                                                                    };
                                                                    if(value==="false") {
                                                                        for(let i = 1;i<16;i++) {
                                                                            if(this.state["price"+i+"type"]==="pulsed")  {
                                                                                obj["price"+i+"type"] = "default";
                                                                            }
                                                                        }
                                                                    }
                                                                    this.setState(obj)
                                                                }}
                                                                inputRef={ref => this.usePulsesRef=ref}
                                        />

                                        {this.state.usePulses==="true" ? (
                                            <>
                                                <ValidatedFormComponent name="Output Frequency"
                                                                        append="Hz"
                                                                        type="number"
                                                                        placeholder=""
                                                                        min={1}
                                                                        max={20}
                                                                        step={1}
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.pulseFreq == null ? 2 : this.state.pulseFreq}
                                                                        onChange={(value) => this.setState({pulseFreq: parseInt(value)})}
                                                                        inputRef={ref => this.pulseFreqRef=ref}
                                                />
                                                <ValidatedFormComponent name="Output Pin"
                                                                        type="number"
                                                                        placeholder=""
                                                                        min={1}
                                                                        max={8}
                                                                        step={1}
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.pulsePin == null ? 2 : this.state.pulsePin}
                                                                        onChange={(value) => this.setState({pulsePin: parseInt(value)})}
                                                                        inputRef={ref => this.pulsePinRef=ref}
                                                />
                                            </>
                                        ) : ""}


                                        <ValidatedFormComponent name="Busy pin"
                                                                type="boolean"
                                                                defaultValue={false}
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={""+(this.state.busyPin!==0 && this.state.busyPin!=null)}
                                                                onChange={(value) => this.setState({busyPin: value=="true" ? 1 : 0})}
                                                                inputRef={ref => this.busyPinEnableRef=ref}
                                        />

                                        {this.state.busyPin>0 ? (
                                            <ValidatedFormComponent name=""
                                                                    type="number"
                                                                    placeholder=""
                                                                    min={1}
                                                                    max={8}
                                                                    step={1}
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.busyPin == null ? 1 : this.state.busyPin}
                                                                    onChange={(value) => this.setState({busyPin: parseInt(value)})}
                                                                    inputRef={ref => this.busyPinRef=ref}
                                            />
                                        ) : ""}

                                        <Row>
                                            <h3><i className="fa fa-credit-card"></i> Payment methods</h3>
                                        </Row>

                                        <ValidatedFormComponent name="Cashless"
                                                                type="boolean"
                                                                defaultValue={false}
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={""+(this.state.mypos!=='nil')}
                                                                onChange={(value) => this.setState({mypos: value=="true" ? "true" : "nil"})}
                                                                inputRef={ref => this.cashlessEnableRef=ref}
                                        />

                                        {this.state.mypos!=='nil' ? (
                                            <>
                                                <ValidatedFormComponent name="Cashless device type"
                                                                        type="select"
                                                                        placeholder=""
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value_key='value'
                                                                        display_name_key='name'
                                                                        options={[
                                                                            {
                                                                                value: 'true',
                                                                                name: 'MyPOS'
                                                                            },
                                                                            {
                                                                                value: 'false',
                                                                                name: 'MDB Cashless'
                                                                            }
                                                                        ]}
                                                                        value={this.state.mypos == null ? "false" : this.state.mypos}
                                                                        onChange={(value) => this.setState({mypos: value})}
                                                                        inputRef={ref => this.myposRef=ref}
                                                />

                                                {this.state.mypos==="true" ? (
                                                    <ValidatedFormComponent name="Currency code"
                                                                            type="text"
                                                                            placeholder=""
                                                                            onValidate={input => {
                                                                                return null;
                                                                            }}
                                                                            value={this.state.currency == null ? "978" : this.state.currency}
                                                                            onChange={(value) => this.setState({currency: value})}
                                                                            inputRef={ref => this.currencyRef=ref}
                                                    />
                                                ) : this.state.mypos==="false" ? (
                                                    <ValidatedFormComponent name="Default product ID"
                                                                            type="number"
                                                                            placeholder=""
                                                                            min={0}
                                                                            max={15}
                                                                            step={1}
                                                                            onValidate={input => {
                                                                                return null;
                                                                            }}
                                                                            value={this.state.defaultPriceLevel == null ? 0 : this.state.defaultPriceLevel}
                                                                            onChange={(value) => this.setState({defaultPriceLevel: parseInt(value)})}
                                                                            inputRef={ref => this.defaultPriceLevelRef=ref}
                                                    />
                                                ) : ""}

                                                <ValidatedFormComponent name="Vend timeout"
                                                                        type="number"
                                                                        placeholder=""
                                                                        min={5}
                                                                        max={300}
                                                                        step={1}
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.vendTimeout == null ? 60 : this.state.vendTimeout}
                                                                        onChange={(value) => this.setState({vendTimeout: parseInt(value)})}
                                                                        inputRef={ref => this.vendTimeoutRef=ref}
                                                />
                                            </>
                                        ) : ""}


                                        <ValidatedFormComponent name="Coins"
                                                                type="boolean"
                                                                defaultValue={false}
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={(this.state.coinAcceptorPin!==0)+""}
                                                                onChange={(value) => this.setState({coinAcceptorPin: value=="true" ? 1 : 0})}
                                                                inputRef={ref => this.coinAcceptorEnableRef=ref}
                                        />

                                        {this.state.coinAcceptorPin!==0 ? (
                                            <ValidatedFormComponent name="Coin acceptor type"
                                                                    type="select"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value_key='value'
                                                                    display_name_key='name'
                                                                    options={[
                                                                        {
                                                                            value: 'gpio',
                                                                            name: 'GPIO Coin acceptor'
                                                                        },
                                                                        {
                                                                            value: 'mdb',
                                                                            name: 'MDB Coin acceptor'
                                                                        }
                                                                    ]}
                                                                    value={this.state.coinAcceptorPin > 0 ? "gpio" : "mdb"}
                                                                    onChange={(value) => this.setState({coinAcceptorPin: value==="gpio" ? 1 : -1})}
                                                                    inputRef={ref => this.coinAcceptorTypeRef=ref}
                                            />) : ""
                                        }

                                        {this.state.coinAcceptorPin>0 ? (
                                            <>

                                                <ValidatedFormComponent name="Coin acceptor pin"
                                                                        type="number"
                                                                        defaultValue={1}
                                                                        placeholder=""
                                                                        min={1}
                                                                        max={8}
                                                                        step={1}
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.coinAcceptorPin == null ? 0 : this.state.coinAcceptorPin}
                                                                        onChange={(value) => this.setState({coinAcceptorPin: parseInt(value)})}
                                                                        inputRef={ref => this.coinAcceptorPinRef=ref}
                                                />
                                                <ValidatedFormComponent name="Enable pin"
                                                                        type="number"
                                                                        defaultValue={0}
                                                                        placeholder=""
                                                                        min={0}
                                                                        max={8}
                                                                        step={1}
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.coinAcceptorEnablePin == null ? 0 : this.state.coinAcceptorEnablePin}
                                                                        onChange={(value) => this.setState({coinAcceptorEnablePin: parseInt(value)})}
                                                                        inputRef={ref => this.coinAcceptorEnablePinRef=ref}
                                                />
                                                <ValidatedFormComponent name="Pulse value"
                                                                        type="number"
                                                                        defaultValue={0.1}
                                                                        placeholder=""
                                                                        min={0.01}
                                                                        max={10}
                                                                        step={0.01}
                                                                        decimal={true}
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.coinAcceptorPulseValue == null ? 0.1 : this.state.coinAcceptorPulseValue}
                                                                        onChange={(value) => this.setState({coinAcceptorPulseValue: parseFloat(value)})}
                                                                        inputRef={ref => this.coinAcceptorPulseValueRef=ref}
                                                />
                                            </>
                                        ) : ""}

                                        <ValidatedFormComponent name="Cloud payments"
                                                                type="boolean"
                                                                defaultValue={false}
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.useCloudPayments == null ? "false" : this.state.useCloudPayments}
                                                                onChange={(value) => this.setState({useCloudPayments: value})}
                                                                inputRef={ref => this.useCloudPaymentsRef=ref}
                                        />

                                        {this.state.useCloudPayments==="true" ? (
                                            <>
                                                <ValidatedFormComponent name="Use SIM800C modem"
                                                                        type="boolean"
                                                                        defaultValue={false}
                                                                        placeholder=""
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.useModem == null ? false : ""+this.state.useModem}
                                                                        onChange={(value) => this.setState({useModem: value==="true"})}
                                                                        inputRef={ref => this.useModemRef=ref}
                                                />

                                                <ValidatedFormComponent name="Keep alive timeout"
                                                                        type="number"
                                                                        placeholder=""
                                                                        min={30}
                                                                        max={7200}
                                                                        step={1}
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.cloudKeepalive == null ? 120 : this.state.cloudKeepalive}
                                                                        onChange={(value) => this.setState({cloudKeepalive: parseInt(value)})}
                                                                        inputRef={ref => this.cloudKeepaliveRef=ref}
                                                />

                                                <ValidatedFormComponent name="Twint mail user"
                                                                        type="text"
                                                                        placeholder=""
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.mailUser == null ? "" : this.state.mailUser}
                                                                        onChange={(value) => this.setState({mailUser: value})}
                                                                        inputRef={ref => this.mailUserRef=ref}
                                                                        append={"@qibipay.com"}
                                                />

                                                <ValidatedFormComponent name="Twint cashregister ID"
                                                                        type="text"
                                                                        placeholder=""
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.cashregisterId == null ? "" : this.state.cashregisterId}
                                                                        onChange={(value) => this.setState({cashregisterId: value})}
                                                                        inputRef={ref => this.cashregisterIdRef=ref}
                                                />

                                                <ValidatedFormComponent name="Twint merchant UUID"
                                                                        type="text"
                                                                        placeholder=""
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.merchantUuid == null ? "" : this.state.merchantUuid}
                                                                        onChange={(value) => this.setState({merchantUuid: value})}
                                                                        inputRef={ref => this.merchantUuidRef=ref}
                                                />
                                            </>
                                        ) : ""}


                                        <ValidatedFormComponent name="Watch-only coin acceptor"
                                                                type="boolean"
                                                                defaultValue={false}
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={""+(this.state.watchCoinAcceptorPin!==0 && this.state.watchCoinAcceptorPin!=null)}
                                                                onChange={(value) => this.setState({watchCoinAcceptorPin: value=="true" ? 1 : 0})}
                                                                inputRef={ref => this.watchCoinAcceptorPinEnableRef=ref}
                                        />

                                        {this.state.watchCoinAcceptorPin>0 ? (
                                            <>
                                                <ValidatedFormComponent name="Pin"
                                                                        type="number"
                                                                        placeholder=""
                                                                        min={1}
                                                                        max={8}
                                                                        step={1}
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.watchCoinAcceptorPin == null ? 1 : this.state.watchCoinAcceptorPin}
                                                                        onChange={(value) => this.setState({watchCoinAcceptorPin: parseInt(value)})}
                                                                        inputRef={ref => this.watchCoinAcceptorPinRef=ref}
                                                />

                                                <ValidatedFormComponent name="Pulse value"
                                                                        type="number"
                                                                        placeholder=""
                                                                        decimal={true}
                                                                        min={0.01}
                                                                        max={500}
                                                                        step={0.01}
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.watchCoinAcceptorPulseValue || 0.1}
                                                                        onChange={(value) => this.setState({watchCoinAcceptorPulseValue: parseFloat(value)})}
                                                                        inputRef={ref => this.watchCoinAcceptorPulseValueRef=ref}
                                                />

                                                <ValidatedFormComponent name="Timeout (ms)"
                                                                        type="number"
                                                                        placeholder=""
                                                                        min={10}
                                                                        max={60000}
                                                                        step={1}
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.watchCoinAcceptorTimeoutMillis || 1000}
                                                                        onChange={(value) => this.setState({watchCoinAcceptorTimeoutMillis: parseInt(value)})}
                                                                        inputRef={ref => this.watchCoinAcceptorTimeoutMillisRef=ref}
                                                />
                                            </>
                                        ) : ""}

                                    </>
                                ) : ""}

                            </Col>
                            {this.state.type==="twint" ? (

                                <Fragment>

                                    <Col  className={this.props.device==null ? "" : "pl-5"} xs={12} sm={12} md={12} lg={this.props.device==null ? 12 : 6}>

                                        <Row>
                                            <h3><i className="fa fa-list"></i> Options</h3>
                                        </Row>
                                            <ValidatedFormComponent name="MDB Address"
                                                                    type="select"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value_key='value'
                                                                    display_name_key='name'
                                                                    options={[
                                                                        {
                                                                            value: '0x10',
                                                                            name: '0x10'
                                                                        },
                                                                        {
                                                                            value: '0x60',
                                                                            name: '0x60'
                                                                        }
                                                                    ]}
                                                                    value={this.state.mdbAddr == null ? "0x10" : this.state.mdbAddr}
                                                                    onChange={(value) => this.setState({mdbAddr: value})}
                                                                    inputRef={ref => this.mdbAddrRef=ref}
                                            />


                                            <ValidatedFormComponent name="MDB Always idle"
                                                                    type="boolean"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.alwaysIdle == null ? "true" : ""+this.state.alwaysIdle}
                                                                    onChange={(value) => this.setState({alwaysIdle: value==="true"})}
                                                                    inputRef={ref => this.alwaysIdleRef=ref}
                                            />

                                            {(this.state.alwaysIdle == null ? "true" : ""+this.state.alwaysIdle)==="false" ? (
                                                <>
                                                    <ValidatedFormComponent name="Authorize amount"
                                                                            type="number"
                                                                            placeholder=""
                                                                            min={0}
                                                                            max={500}
                                                                            step={0.01}
                                                                            decimal={true}
                                                                            onValidate={input => {
                                                                                return null;
                                                                            }}
                                                                            value={this.state.authAmount == null ? 5 : this.state.authAmount}
                                                                            onChange={(value) => this.setState({authAmount: value})}
                                                                            inputRef={ref => this.authAmountRef=ref}
                                                    />
                                                </>
                                            ) : ""}

                                            <ValidatedFormComponent name="Peripheral"
                                                                    type="select"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value_key='value'
                                                                    display_name_key='name'
                                                                    options={(this.state.alwaysIdle == null ? "true" : ""+this.state.alwaysIdle)==="false" ? [
                                                                        {
                                                                            value: 'beacon',
                                                                            name: 'Twint Beacon'
                                                                        }
                                                                    ] : [
                                                                        {
                                                                            value: 'beacon',
                                                                            name: 'Twint Beacon'
                                                                        },
                                                                        {
                                                                            value: 'qrcode',
                                                                            name: 'QR code display'
                                                                        }
                                                                    ]}
                                                                    value={this.state.beaconType == null ? "beacon" : this.state.beaconType}
                                                                    onChange={(value) => this.setState({beaconType: value})}
                                                                    inputRef={ref => this.beaconTypeRef=ref}
                                            />

                                            <ValidatedFormComponent name="Vend timeout (s)"
                                                                    type="number"
                                                                    placeholder=""
                                                                    min={5}
                                                                    max={300}
                                                                    step={1}
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.vendTimeout == null ? 60 : this.state.vendTimeout}
                                                                    onChange={(value) => this.setState({vendTimeout: value})}
                                                                    inputRef={ref => this.vendTimeoutRef=ref}
                                            />

                                            <ValidatedFormComponent name="Currency"
                                                                    type="select"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value_key='value'
                                                                    display_name_key='name'
                                                                    options={[
                                                                        {
                                                                            value: 'CHF',
                                                                            name: 'CHF'
                                                                        },
                                                                        {
                                                                            value: 'USD',
                                                                            name: 'USD'
                                                                        },
                                                                        {
                                                                            value: 'EUR',
                                                                            name: 'EUR'
                                                                        }
                                                                    ]}
                                                                    value={this.state.currencyCode == null ? "CHF" : this.state.currencyCode}
                                                                    onChange={(value) => this.setState({currencyCode: value})}
                                                                    inputRef={ref => this.currencyCodeRef=ref}
                                            />

                                            <ValidatedFormComponent name="Twint cashregister ID"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.cashregisterId == null ? "" : this.state.cashregisterId}
                                                                    onChange={(value) => this.setState({cashregisterId: value})}
                                                                    inputRef={ref => this.cashregisterIdRef=ref}
                                            />

                                            <ValidatedFormComponent name="Twint merchant UUID"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.merchantUuid == null ? "" : this.state.merchantUuid}
                                                                    onChange={(value) => this.setState({merchantUuid: value})}
                                                                    inputRef={ref => this.merchantUuidRef=ref}
                                            />
                                            <Row>
                                                <h3>Advanced</h3>
                                            </Row>
                                            <ValidatedFormComponent name="Log UDP address"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.logUdpAddr == null ? "" : this.state.logUdpAddr}
                                                                    onChange={(value) => this.setState({logUdpAddr: value})}
                                                                    inputRef={ref => this.logUdpAddrRef=ref}
                                            />
                                            <ValidatedFormComponent name="Log UDP port"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        if(input==="") return null;
                                                                        const i = parseInt(input);
                                                                        if(i==null) return "Not a number";
                                                                        if(i>65535) return "Cannot be >65535";
                                                                        if(i<0) return "Cannot be <0";
                                                                        return null;
                                                                    }}
                                                                    value={this.state.logUdpPort == null ? "" : this.state.logUdpPort}
                                                                    onChange={(value) => this.setState({logUdpPort: value})}
                                                                    inputRef={ref => this.logUdpPortRef=ref}
                                            />
                                    </Col>
                                </Fragment>

                            ) : this.state.type==="twintqr" ? (

                                <Fragment>

                                    <Col  className={this.props.device==null ? "" : "pl-5"} xs={12} sm={12} md={12} lg={this.props.device==null ? 12 : 6}>

                                        <Row>
                                            <h3><i className="fa fa-list"></i> Options</h3>
                                        </Row>
                                        <ValidatedFormComponent name="MDB Address"
                                                                type="select"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value_key='value'
                                                                display_name_key='name'
                                                                options={[
                                                                    {
                                                                        value: '0x10',
                                                                        name: '0x10'
                                                                    },
                                                                    {
                                                                        value: '0x60',
                                                                        name: '0x60'
                                                                    }
                                                                ]}
                                                                value={this.state.mdbAddr == null ? "0x10" : this.state.mdbAddr}
                                                                onChange={(value) => this.setState({mdbAddr: value})}
                                                                inputRef={ref => this.mdbAddrRef=ref}
                                        />


                                        <ValidatedFormComponent name="Auto-credit"
                                                                type="boolean"
                                                                defaultValue={false}
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.autoCredit == null ? "false" : ""+this.state.autoCredit}
                                                                onChange={(value) => this.setState({autoCredit: value==="true"})}
                                                                inputRef={ref => {
                                                                    this.autocreditRef=ref
                                                                }}
                                        />

                                        <ValidatedFormComponent name="Authorize amount"
                                                                type="number"
                                                                placeholder=""
                                                                min={0.01}
                                                                max={500}
                                                                step={0.01}
                                                                decimal={true}
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.authAmount == null ? 5 : this.state.authAmount}
                                                                onChange={(value) => this.setState({authAmount: value})}
                                                                inputRef={ref => this.authAmountRef=ref}
                                        />

                                        <ValidatedFormComponent name="Vend timeout (s)"
                                                                type="number"
                                                                placeholder=""
                                                                min={5}
                                                                max={300}
                                                                step={1}
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.vendTimeout == null ? 60 : this.state.vendTimeout}
                                                                onChange={(value) => this.setState({vendTimeout: value})}
                                                                inputRef={ref => this.vendTimeoutRef=ref}
                                        />

                                        <ValidatedFormComponent name="Currency"
                                                                type="select"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value_key='value'
                                                                display_name_key='name'
                                                                options={[
                                                                    {
                                                                        value: 'CHF',
                                                                        name: 'CHF'
                                                                    },
                                                                    {
                                                                        value: 'USD',
                                                                        name: 'USD'
                                                                    },
                                                                    {
                                                                        value: 'EUR',
                                                                        name: 'EUR'
                                                                    }
                                                                ]}
                                                                value={this.state.currencyCode == null ? "CHF" : this.state.currencyCode}
                                                                onChange={(value) => this.setState({currencyCode: value})}
                                                                inputRef={ref => this.currencyCodeRef=ref}
                                        />

                                        <ValidatedFormComponent name="Cashless passthrough"
                                                                type="boolean"
                                                                defaultValue={false}
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.usePassthrough == null ? false : ""+this.state.usePassthrough}
                                                                onChange={(value) => this.setState({usePassthrough: value==="true"})}
                                                                inputRef={ref => this.passthroughRef=ref}
                                        />

                                        <ValidatedFormComponent name="Twint cashregister ID"
                                                                type="text"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.cashregisterId == null ? "" : this.state.cashregisterId}
                                                                onChange={(value) => this.setState({cashregisterId: value})}
                                                                inputRef={ref => this.cashregisterIdRef=ref}
                                        />
                                        <ValidatedFormComponent name="Twint merchant UUID"
                                                                type="text"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.merchantUuid == null ? "" : this.state.merchantUuid}
                                                                onChange={(value) => this.setState({merchantUuid: value})}
                                                                inputRef={ref => this.merchantUuidRef=ref}
                                        />
                                        <Row>
                                            <h3>Advanced</h3>
                                        </Row>
                                        <ValidatedFormComponent name="Log UDP address"
                                                                type="text"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.logUdpAddr == null ? "" : this.state.logUdpAddr}
                                                                onChange={(value) => this.setState({logUdpAddr: value})}
                                                                inputRef={ref => this.logUdpAddrRef=ref}
                                        />
                                        <ValidatedFormComponent name="Log UDP port"
                                                                type="text"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    if(input==="") return null;
                                                                    const i = parseInt(input);
                                                                    if(i==null) return "Not a number";
                                                                    if(i>65535) return "Cannot be >65535";
                                                                    if(i<0) return "Cannot be <0";
                                                                    return null;
                                                                }}
                                                                value={this.state.logUdpPort == null ? "" : this.state.logUdpPort}
                                                                onChange={(value) => this.setState({logUdpPort: value})}
                                                                inputRef={ref => this.logUdpPortRef=ref}
                                        />
                                    </Col>
                                </Fragment>

                            ) : this.state.type==='tele' ? (

                                <Fragment>

                                    <Col  className={this.props.device==null ? "" : "pl-5"} xs={12} sm={12} md={12} lg={this.props.device==null ? 12 : 6}>

                                        <Row>
                                            <h3><i className="fa fa-list"></i> Options</h3>
                                        </Row>
                                        <ValidatedFormComponent name="MDB Address"
                                                                type="select"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value_key='value'
                                                                display_name_key='name'
                                                                options={[
                                                                    {
                                                                        value: '0x10',
                                                                        name: '0x10'
                                                                    },
                                                                    {
                                                                        value: '0x60',
                                                                        name: '0x60'
                                                                    }
                                                                ]}
                                                                value={this.state.cashless_address == null ? "0x60" : this.state.cashless_address}
                                                                onChange={(value) => this.setState({cashless_address: value})}
                                                                inputRef={ref => this.cashless_addressRef=ref}
                                        />

                                        <ValidatedFormComponent name="Act as cashless"
                                                                type="boolean"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.be_cashless == null ? "false" : ""+this.state.be_cashless}
                                                                onChange={(value) => this.setState({be_cashless: value})}
                                                                inputRef={ref => this.be_cashlessRef=ref}
                                        />

                                    </Col>
                                </Fragment>

                            ) :  this.state.type==='relay' ? (

                                <Fragment>

                                    <Col  className={this.props.device==null ? "" : "pl-5"} xs={12} sm={12} md={12} lg={this.props.device==null ? 12 : 6}>

                                        <Row>
                                            <h3><i className="fa fa-list"></i> Options</h3>
                                        </Row>
                                        <ValidatedFormComponent name="Relay activation price"
                                                                type="number"
                                                                value={this.state.activationPrice}
                                                                onChange={(value) => this.setState({activationPrice: value})}
                                                                decimal
                                                                min={0.01}
                                                                step={0.01}
                                                                placeholder="Enter device's relay activation price"
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                inputRef={ref => this.activationPriceRef=ref}
                                        />

                                        <ValidatedFormComponent name="Input type"
                                                                type="select"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value_key='value'
                                                                display_name_key='name'
                                                                options={[
                                                                    {
                                                                        value: 'hid',
                                                                        name: 'HID'
                                                                    },
                                                                    {
                                                                        value: 'serial',
                                                                        name: 'Serial'
                                                                    },
                                                                    {
                                                                        value: 'cloud',
                                                                        name: 'Cloud (static QR)'
                                                                    }
                                                                ]}
                                                                value={this.state.inputType == null ? "hid" : this.state.inputType}
                                                                onChange={(value) => this.setState({inputType: value})}
                                                                inputRef={ref => this.inputTypeRef=ref}
                                        />
                                        {this.state.inputType==="cloud" ? (
                                            <ValidatedFormComponent name="Vend timeout (s)"
                                                                    type="number"
                                                                    placeholder=""
                                                                    min={5}
                                                                    max={300}
                                                                    step={1}
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.cloudPayVendTimeout == null ? 60 : this.state.cloudPayVendTimeout}
                                                                    onChange={(value) => this.setState({cloudPayVendTimeout: value})}
                                                                    inputRef={ref => this.cloudPayVendTimeoutRef=ref}
                                            />
                                        ) : ""}
                                        {this.state.inputType==="serial" ? (
                                            <ValidatedFormComponent name="Serial baudrate"
                                                                    type="select"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value_key='value'
                                                                    display_name_key='value'
                                                                    options={[
                                                                        {
                                                                            value: '300'
                                                                        },
                                                                        {
                                                                            value: '2400'
                                                                        },
                                                                        {
                                                                            value: '4800'
                                                                        },
                                                                        {
                                                                            value: '9600'
                                                                        },
                                                                        {
                                                                            value: '19200'
                                                                        },
                                                                        {
                                                                            value: '38400'
                                                                        },
                                                                        {
                                                                            value: '57600'
                                                                        },
                                                                        {
                                                                            value: '115200'
                                                                        },
                                                                        {
                                                                            value: '460800'
                                                                        }
                                                                    ]}
                                                                    value={this.state.inputBaud == null ? "115200" : this.state.inputBaud}
                                                                    onChange={(value) => this.setState({inputBaud: value})}
                                                                    inputRef={ref => this.inputBaudRef=ref}
                                            />
                                        ) : ""}
                                    </Col>
                                </Fragment>

                            ) : this.state.type==="mdb" ? (

                                <Fragment>

                                    <Col  className={this.props.device==null ? "" : "pl-5"} xs={12} sm={12} md={12} lg={this.props.device==null ? 12 : 6}>

                                        <Row>
                                            <h3><i className="fa fa-list"></i> Options</h3>
                                        </Row>

                                        <ValidatedFormComponent name="MDB Address"
                                                                type="select"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value_key='value'
                                                                display_name_key='name'
                                                                options={[
                                                                    {
                                                                        value: '0x10',
                                                                        name: '0x10'
                                                                    },
                                                                    {
                                                                        value: '0x60',
                                                                        name: '0x60'
                                                                    }
                                                                ]}
                                                                value={this.state.mdbAddr == null ? "0x10" : this.state.mdbAddr}
                                                                onChange={(value) => this.setState({mdbAddr: value})}
                                                                inputRef={ref => this.mdbAddrRef=ref}
                                        />

                                        <ValidatedFormComponent name="Input type"
                                                                type="select"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value_key='value'
                                                                display_name_key='name'
                                                                options={[
                                                                    {
                                                                        value: 'hid',
                                                                        name: 'HID'
                                                                    },
                                                                    {
                                                                        value: 'serial',
                                                                        name: 'Serial'
                                                                    },
                                                                    {
                                                                        value: 'cloud',
                                                                        name: 'Cloud (static QR)'
                                                                    }
                                                                ]}
                                                                value={this.state.inputType == null ? "hid" : this.state.inputType}
                                                                onChange={(value) => this.setState({inputType: value})}
                                                                inputRef={ref => this.inputTypeRef=ref}
                                        />
                                        {this.state.inputType==="cloud" ? (
                                            <ValidatedFormComponent name="Vend timeout (s)"
                                                                    type="number"
                                                                    placeholder=""
                                                                    min={5}
                                                                    max={300}
                                                                    step={1}
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.cloudPayVendTimeout == null ? 60 : this.state.cloudPayVendTimeout}
                                                                    onChange={(value) => this.setState({cloudPayVendTimeout: value})}
                                                                    inputRef={ref => this.cloudPayVendTimeoutRef=ref}
                                            />
                                        ) : ""}
                                        {this.state.inputType==="serial" ? (
                                            <ValidatedFormComponent name="Serial baudrate"
                                                                    type="select"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value_key='value'
                                                                    display_name_key='value'
                                                                    options={[
                                                                        {
                                                                            value: '300'
                                                                        },
                                                                        {
                                                                            value: '2400'
                                                                        },
                                                                        {
                                                                            value: '4800'
                                                                        },
                                                                        {
                                                                            value: '9600'
                                                                        },
                                                                        {
                                                                            value: '19200'
                                                                        },
                                                                        {
                                                                            value: '38400'
                                                                        },
                                                                        {
                                                                            value: '57600'
                                                                        },
                                                                        {
                                                                            value: '115200'
                                                                        },
                                                                        {
                                                                            value: '460800'
                                                                        }
                                                                    ]}
                                                                    value={this.state.inputBaud == null ? "115200" : this.state.inputBaud}
                                                                    onChange={(value) => this.setState({inputBaud: value})}
                                                                    inputRef={ref => this.inputBaudRef=ref}
                                            />
                                        ) : ""}
                                    </Col>
                                </Fragment>
                            ) : this.state.type==="vimasim" ? (

                                <Fragment>

                                    <Col  className={this.props.device==null ? "" : "pl-5"} xs={12} sm={12} md={12} lg={this.props.device==null ? 12 : 6}>

                                        <Row>
                                            <h3><i className="fa fa-list"></i> Options</h3>
                                        </Row>
                                    <ValidatedFormComponent name="Verbosity"
                                                            type="select"
                                                            placeholder=""
                                                            onValidate={input => {
                                                                return null;
                                                            }}
                                                            value_key='value'
                                                            display_name_key='name'
                                                            options={[
                                                                {
                                                                    value: '5',
                                                                    name: 'Trace'
                                                                },
                                                                {
                                                                    value: '4',
                                                                    name: 'Debug'
                                                                },
                                                                {
                                                                    value: "3",
                                                                    name: "Info"
                                                                },
                                                                {
                                                                    value: "2",
                                                                    name: "Warn"
                                                                },
                                                                {
                                                                    value: "1",
                                                                    name: "Error"
                                                                },
                                                                {
                                                                    value: "0",
                                                                    name: "Fatal"
                                                                }
                                                            ]}
                                                            value={this.state.logLevel == null ? "3" : this.state.logLevel}
                                                            onChange={(value) => this.setState({logLevel: value})}
                                                            inputRef={ref => this.logLevelRef=ref}
                                    />

                                    <ValidatedFormComponent name="Log to"
                                                            type="select"
                                                            placeholder=""
                                                            onValidate={input => {
                                                                return null;
                                                            }}
                                                            value_key='value'
                                                            display_name_key='name'
                                                            options={[
                                                                {
                                                                    value: 'ram',
                                                                    name: 'RAM'
                                                                },
                                                                {
                                                                    value: 'rom',
                                                                    name: 'ROM'
                                                                },
                                                                {
                                                                    value: "udp",
                                                                    name: "UDP"
                                                                }
                                                            ]}
                                                            value={this.state.logTarget == null ? "ram" : this.state.logTarget}
                                                            onChange={(value) => this.setState({logTarget: value})}
                                                            inputRef={ref => this.logTargetRef=ref}
                                    />

                                    {this.state.logTarget === "udp" ? (
                                        <div>
                                            <ValidatedFormComponent name="UDP Address"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.logUdpAddress == null ? "192.168.1.1" : this.state.logUdpAddress}
                                                                    onChange={(value) => this.setState({logUdpAddress: value})}
                                                                    inputRef={ref => this.logUdpAddressRef=ref}
                                            />
                                            <ValidatedFormComponent name="UDP Port"
                                                                    type="number"
                                                                    min={1}
                                                                    max={65535}
                                                                    step={1}
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.logUdpPort == null ? 15427 : this.state.logUdpPort}
                                                                    onChange={(value) => this.setState({logUdpPort: value})}
                                                                    inputRef={ref => this.logUdpPortRef=ref}
                                            />
                                        </div>
                                    ) : ""}

                                    <ValidatedFormComponent name="Currency symbol"
                                                            type="text"
                                                            placeholder=""
                                                            onValidate={input => {
                                                                return null;
                                                            }}
                                                            value={this.state.currencySymbol == null ? "EUR" : this.state.currencySymbol}
                                                            onChange={(value) => this.setState({currencySymbol: value})}
                                                            inputRef={ref => this.currencySymbolRef=ref}
                                    />

                                    <ValidatedFormComponent name="UI"
                                                            type="select"
                                                            placeholder=""
                                                            onValidate={input => {
                                                                return null;
                                                            }}
                                                            value_key='value'
                                                            display_name_key='name'
                                                            options={[
                                                                {
                                                                    value: 'web',
                                                                    name: 'Web (only raspi)'
                                                                },
                                                                {
                                                                    value: 'nextion',
                                                                    name: 'Nextion'
                                                                }
                                                            ]}
                                                            value={this.state.ui == null ? "nextion" : this.state.ui}
                                                            onChange={(value) => this.setState({ui: value})}
                                                            inputRef={ref => this.uiRef=ref}
                                    />

                                    {this.state.ui==="web" ? (
                                        <ValidatedFormComponent name="Websocket port"
                                                                type="number"
                                                                min={1}
                                                                max={65535}
                                                                step={1}
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.websocketPort == null ? 15427 : this.state.websocketPort}
                                                                onChange={(value) => this.setState({websocketPort: value})}
                                                                inputRef={ref => this.websocketPortRef=ref}
                                        />
                                    ) : ""}


                                    <ValidatedFormComponent name="Enable vemio"
                                                            type="boolean"
                                                            placeholder=""
                                                            onValidate={input => {
                                                                return null;
                                                            }}
                                                            value={this.state.useVemio == null ? "true" : this.state.useVemio}
                                                            onChange={(value) => this.setState({useVemio: value})}
                                                            inputRef={ref => this.useVemioRef=ref}
                                    />

                                    <ValidatedFormComponent name="Always-idle mode"
                                                            type="boolean"
                                                            placeholder=""
                                                            onValidate={input => {
                                                                return null;
                                                            }}
                                                            value={this.state.alwaysIdle == null ? "true" : this.state.alwaysIdle}
                                                            onChange={(value) => this.setState({alwaysIdle: value})}
                                                            inputRef={ref => this.alwaysIdleRef=ref}
                                    />

                                    <ValidatedFormComponent name="Support MDB cashless"
                                                            type="boolean"
                                                            placeholder=""
                                                            onValidate={input => {
                                                                return null;
                                                            }}
                                                            value={this.state.supportCashless == null ? "true" : this.state.supportCashless}
                                                            onChange={(value) => this.setState({supportCashless: value})}
                                                            inputRef={ref => this.supportCashlessRef=ref}
                                    />

                                    <ValidatedFormComponent name="Support MDB cash"
                                                            type="boolean"
                                                            placeholder=""
                                                            onValidate={input => {
                                                                return null;
                                                            }}
                                                            value={this.state.supportCash == null ? "false" : this.state.supportCash}
                                                            onChange={(value) => this.setState({supportCash: value})}
                                                            inputRef={ref => this.supportCashRef=ref}
                                    />

                                    <ValidatedFormComponent name="Support qibaccount"
                                                            type="boolean"
                                                            placeholder=""
                                                            onValidate={input => {
                                                                return null;
                                                            }}
                                                            value={this.state.supportQibaccount == null ? "true" : this.state.supportQibaccount}
                                                            onChange={(value) => this.setState({supportQibaccount: value})}
                                                            inputRef={ref => this.supportQibaccountRef=ref}
                                    />

                                    {this.state.supportQibaccount==="true" ? (
                                        <ValidatedFormComponent name="Qibaccount timeout"
                                                                type="number"
                                                                min={30}
                                                                max={300}
                                                                step={1}
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.qibaccountTimeout == null ? 90 : this.state.qibaccountTimeout}
                                                                onChange={(value) => this.setState({qibaccountTimeout: value})}
                                                                inputRef={ref => this.qibaccountTimeoutRef=ref}
                                        />
                                    ) : ""}

                                    <ValidatedFormComponent name="Support DASH"
                                                            type="boolean"
                                                            placeholder=""
                                                            onValidate={input => {
                                                                return null;
                                                            }}
                                                            value={this.state.supportDash == null ? "false" : this.state.supportDash}
                                                            onChange={(value) => this.setState({supportDash: value})}
                                                            inputRef={ref => this.supportDashRef=ref}
                                    />

                                    {this.state.supportDash==="true" ? (
                                        <div>
                                            <ValidatedFormComponent name="Dash timeout"
                                                                    type="number"
                                                                    min={30}
                                                                    max={300}
                                                                    step={1}
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.dashTimeout == null ? 90 : this.state.dashTimeout}
                                                                    onChange={(value) => this.setState({dashTimeout: value})}
                                                                    inputRef={ref => this.dashTimeoutRef=ref}
                                            />
                                            <ValidatedFormComponent name="Dash address"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onValidate={input => {
                                                                        return null;
                                                                    }}
                                                                    value={this.state.dashAddress == null ? "7gnwGHt17heGpG9Crfeh4KGpYNFugPhJdh" : this.state.dashAddress}
                                                                    onChange={(value) => this.setState({dashAddress: value})}
                                                                    inputRef={ref => this.dashAddressRef=ref}
                                            />
                                        </div>
                                    ) : ""}


                                    <ValidatedFormComponent name="Support TWINT"
                                                                type="boolean"
                                                                placeholder=""
                                                                onValidate={input => {
                                                                    return null;
                                                                }}
                                                                value={this.state.supportTwint == null ? "false" : this.state.supportTwint}
                                                                onChange={(value) => this.setState({supportTwint: value})}
                                                                inputRef={ref => this.supportTwintRef=ref}
                                    />

                                        {this.state.supportTwint==="true" ? (
                                            <div>
                                                <ValidatedFormComponent name="Twint timeout"
                                                                        type="number"
                                                                        min={30}
                                                                        max={300}
                                                                        step={1}
                                                                        placeholder=""
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.twintTimeout == null ? 90 : this.state.twintTimeout}
                                                                        onChange={(value) => this.setState({twintTimeout: value})}
                                                                        inputRef={ref => this.twintTimeoutRef=ref}
                                                />
                                                <ValidatedFormComponent name="Twint cashregister ID"
                                                                        type="text"
                                                                        placeholder=""
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.cashregisterId == null ? "" : this.state.cashregisterId}
                                                                        onChange={(value) => this.setState({cashregisterId: value})}
                                                                        inputRef={ref => this.cashregisterIdRef=ref}
                                                />
                                                <ValidatedFormComponent name="Twint merchant UUID"
                                                                        type="text"
                                                                        placeholder=""
                                                                        onValidate={input => {
                                                                            return null;
                                                                        }}
                                                                        value={this.state.merchantUuid == null ? "" : this.state.merchantUuid}
                                                                        onChange={(value) => this.setState({merchantUuid: value})}
                                                                        inputRef={ref => this.merchantUuidRef=ref}
                                                />
                                            </div>
                                        ) : ""}

                                    <FormGroup controlId={"Recipes"}>
                                        <Row>
                                            <Col componentClass={ControlLabel} sm={4}>
                                                Recipes
                                            </Col>
                                            <Col sm={8}>
                                                <Button bsStyle={"primary"} onClick={() => {
                                                    this.setState({
                                                        chooseRecipesOpen: true
                                                    })
                                                }}>{this.state.recipeName==null ? "None" : this.state.recipeName}</Button>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    </Col>
                                </Fragment>
                            ) : ""}

                            {this.state.type==="contact" ? (
                                <Fragment>

                                    <Col  className={this.props.device==null ? "" : "pl-5"} xs={12} sm={12} md={12} lg={this.props.device==null ? 12 : 6}>

                                    <Row>
                                        <h3><i className="fa fa-bars"></i> Products</h3>
                                    </Row>

                                    {(() => {

                                        const retArr = [];

                                        for(let i=1;i<16;i++) {
                                            let e = i;
                                            if(i<10) {
                                                i = "0"+i;
                                            }
                                            retArr.push((
                                                <div key={i} className={"mt-2"}>
                                                    <Row>
                                                        <h4><i className="fa fa-dot-circle"></i>  Product {e}</h4>
                                                    </Row>

                                                    <ValidatedFormComponent name="QR Name"
                                                                            type="text"
                                                                            placeholder=""
                                                                            onValidate={input => {
                                                                                return null;
                                                                            }}
                                                                            value={this.state["price"+i+"twintqr"] == null ? "" : this.state["price"+i+"twintqr"]}
                                                                            onChange={(value) => this.setState({["price"+i+"twintqr"]: value})}
                                                                            inputRef={ref => this["price"+i+"twintqrRef"]=ref}
                                                    />

                                                    <ValidatedFormComponent name="Price"
                                                                            type="number"
                                                                            placeholder=""
                                                                            min={0.01}
                                                                            max={500}
                                                                            step={0.01}
                                                                            decimal={true}
                                                                            onValidate={input => {
                                                                                return null;
                                                                            }}
                                                                            value={this.state["price"+i] == null ? e : this.state["price"+i]}
                                                                            onChange={(value) => this.setState({["price"+i]: parseFloat(value)})}
                                                                            inputRef={ref => this["price"+i+"Ref"]=ref}
                                                    />

                                                    <ValidatedFormComponent name="Function"
                                                                            type="select"
                                                                            value_key='value'
                                                                            display_name_key='name'
                                                                            options={this.state.usePulses==="true" ? [
                                                                                {
                                                                                    value: 'default',
                                                                                    name: 'Default'
                                                                                },
                                                                                {
                                                                                    value: 'timed',
                                                                                    name: 'Activate Output'
                                                                                },
                                                                                {
                                                                                    value: 'fixed',
                                                                                    name: 'Fixed Value'
                                                                                },
                                                                                {
                                                                                    value: 'pulsed',
                                                                                    name: 'Pulsed'
                                                                                }
                                                                            ] : [
                                                                                {
                                                                                    value: 'default',
                                                                                    name: 'Default'
                                                                                },
                                                                                {
                                                                                    value: 'timed',
                                                                                    name: 'Activate Output'
                                                                                },
                                                                                {
                                                                                    value: 'fixed',
                                                                                    name: 'Fixed Value'
                                                                                }
                                                                            ]}
                                                                            placeholder=""
                                                                            onValidate={input => {
                                                                                return null;
                                                                            }}
                                                                            value={this.state["price"+i+"type"] == null ? "default" : this.state["price"+i+"type"]}
                                                                            onChange={(value) => this.setState({["price"+i+"type"]: value})}
                                                                            inputRef={ref => this["price"+i+"typeRef"]=ref}
                                                    />

                                                    {this.state["price"+i+"type"]==="pulsed" ? (
                                                        <>
                                                            <ValidatedFormComponent name="Output"
                                                                                    type="number"
                                                                                    placeholder=""
                                                                                    min={1}
                                                                                    max={8}
                                                                                    step={1}
                                                                                    decimal={true}
                                                                                    onValidate={input => {
                                                                                        return null;
                                                                                    }}
                                                                                    value={this.state["price"+i+"pin"] == null ? 1 : this.state["price"+i+"pin"]}
                                                                                    onChange={(value) => this.setState({["price"+i+"pin"]: parseInt(value)})}
                                                                                    inputRef={ref => this["price"+i+"pinRef"]=ref}
                                                            />
                                                            <ValidatedFormComponent name="Number of Pulses"
                                                                                    type="number"
                                                                                    placeholder=""
                                                                                    min={1}
                                                                                    max={50}
                                                                                    step={1}
                                                                                    decimal={true}
                                                                                    onValidate={input => {
                                                                                        return null;
                                                                                    }}
                                                                                    value={this.state["price"+i+"pulses"] == null ? 5 : this.state["price"+i+"pulses"]}
                                                                                    onChange={(value) => this.setState({["price"+i+"pulses"]: parseInt(value)})}
                                                                                    inputRef={ref => this["price"+i+"pulsesRef"]=ref}
                                                            />
                                                        </>
                                                    ) : ""}


                                                    {this.state["price"+i+"type"]==="fixed" ? (
                                                        <>
                                                            <ValidatedFormComponent name="Value"
                                                                                    type="number"
                                                                                    placeholder=""
                                                                                    min={1}
                                                                                    max={15}
                                                                                    step={1}
                                                                                    onValidate={input => {
                                                                                        return null;
                                                                                    }}
                                                                                    value={this.state["price"+i+"value"] == null ? 1 : this.state["price"+i+"value"]}
                                                                                    onChange={(value) => this.setState({["price"+i+"value"]: parseInt(value)})}
                                                                                    inputRef={ref => this["price"+i+"valueRef"]=ref}
                                                            />
                                                        </>
                                                    ) : ""}

                                                    {this.state["price"+i+"type"]==="timed" ? (
                                                        <>
                                                            <ValidatedFormComponent name="Output"
                                                                                    type="number"
                                                                                    placeholder=""
                                                                                    min={1}
                                                                                    max={8}
                                                                                    step={1}
                                                                                    decimal={true}
                                                                                    onValidate={input => {
                                                                                        return null;
                                                                                    }}
                                                                                    value={this.state["price"+i+"pin"] == null ? 1 : this.state["price"+i+"pin"]}
                                                                                    onChange={(value) => this.setState({["price"+i+"pin"]: parseInt(value)})}
                                                                                    inputRef={ref => this["price"+i+"pinRef"]=ref}
                                                            />
                                                            <ValidatedFormComponent name="Time"
                                                                                    type="number"
                                                                                    append={"s"}
                                                                                    placeholder=""
                                                                                    min={1}
                                                                                    max={60000}
                                                                                    step={1}
                                                                                    onValidate={input => {
                                                                                        return null;
                                                                                    }}
                                                                                    value={this.state["price"+i+"time"] == null ? 5 : this.state["price"+i+"time"]}
                                                                                    onChange={(value) => this.setState({["price"+i+"time"]: parseInt(value)})}
                                                                                    inputRef={ref => this["price"+i+"timeRef"]=ref}
                                                            />
                                                        </>
                                                    ) : ""}

                                                </div>
                                            ));
                                        }

                                        return retArr;

                                    })()}
                                    </Col>
                                </Fragment>
                            ) : ""}
                        </Form>
                    )}
            </Fragment>
        );
    }


}

export default DeviceConfig;